<template>
  <b-container>
    <b-card no-body>
      <b-tabs>
        <b-tab title="Schools Map" active>
          <div id="data-school">
            <schools-map class="schools-map"></schools-map>
          </div>
        </b-tab>
        <b-tab title="School Structure Table" id="structure-table-tab">
          <div class="title m-4">
            <h4>Count of School Structure by Region</h4>
          </div>
          <b-row class="m-4">
            <b-col>
              <b-input-group>
                <b-form-input v-model="filter" placeholder="Type to Search" />
                <b-input-group-append>
                  <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-col>
          </b-row>

          <b-table
            v-cloak
            responsive
            :fields="fields"
            :items="structureTable"
            :striped="true"
            :bordered="true"
            :hover="true"
            stacked="md"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            @filtered="onFiltered"
          ></b-table>
          <b-row>
            <b-col md="6" class="my-1">
              <b-pagination
                :total-rows="structureTable.length || 0"
                :per-page="perPage"
                v-model="currentPage"
                class="my-0"
              />
            </b-col>
            <b-col>
              <download-button
                :export="structureTable"
                :file="file"
              ></download-button>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </b-card>
  </b-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'DataSchool',
  components: {
    SchoolsMap: () => import("@/components/SchoolsMap"),
    DownloadButton: () => import("@/components/DownloadButton"),
  },
  data() {
    return {
      file: 'schools-structure-summary-table',
      fields: [
        { key: 'country', label: 'Country', sortable: true },
        { key: 'region', label: 'Region', sortable: true },
        { key: 'outdoor', label: 'Outdoor', sortable: true },
        { key: 'tin_shack', label: 'Tin Shack', sortable: true },
        { key: 'mud_buildings', label: 'Mud Buildings', sortable: true },
        { key: 'brick_buildings', label: 'Brick Buildings', sortable: true },
        {
          key: 'classroom_count',
          label: 'Classroom Count (Avg)',
          sortable: true,
        },
        {
          key: 'classroom_count_sufficient',
          label: 'Classroom Count Sufficient?',
          sortable: true,
        },
        { key: 'running_water', label: 'Running Water', sortable: true },
        { key: 'tippy_tap', label: 'Tippy Tap', sortable: true },
        { key: 'bucket_of_water', label: 'Bucket Water', sortable: true },
        { key: 'no_water', label: 'No Water', sortable: true },
        { key: 'flushing_toilet', label: 'Flush Toilet', sortable: true },
        { key: 'pit_toilet', label: 'Pit Toilet', sortable: true },
        {
          key: 'male_female_toilet',
          label: 'Male/Female Toilets',
          sortable: true,
        },
        { key: 'no_toilet', label: 'No Toilet', sortable: true },
        { key: 'no_tables_chairs', label: 'No Tables/Chairs', sortable: true },
        {
          key: 'some_tables_chairs',
          label: 'Some Tables/Chairs',
          sortable: true,
        },
        {
          key: 'sufficient_tables_chairs',
          label: 'Sufficient Tables/Chairs',
          sortable: true,
        },
        {
          key: 'no_teaching_materials',
          label: 'No Teaching Materials',
          sortable: true,
        },
        {
          key: 'some_teaching_materials',
          label: 'Some Teaching Materials',
          sortable: true,
        },
        {
          key: 'sufficient_teaching_materials',
          label: 'Sufficient Teaching Materials',
          sortable: true,
        },
        { key: 'urban', label: 'Urban', sortable: true },
        { key: 'rural', label: 'Rural', sortable: true },
      ],
      currentPage: 0,
      perPage: 50,
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
    };
  },
  methods: {
    ...mapActions({
      GET_STRUCTURE_TABLE: 'dashboards/GET_STRUCTURE_TABLE',
    }),
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    stopClick(row) {},
  },
  computed: {
    structureTable() {
      return this.$store.state.dashboards.structureTable;
    },
  },
  mounted() {
    this.GET_STRUCTURE_TABLE();
  },
};
</script>

<style scoped>
.schools-map {
  height: 600px;
}

#structure-table-tab {
  overflow-x: scroll;
}
</style>
